import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const ChatRoomOpenWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 71px;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: 1px solid ${COLORS.line};
  background-color: ${COLORS.black};
`;

export default ChatRoomOpenWrapper;
